import { Box, Button } from "@mui/material";
import { useFormik } from "formik";
import { useCallback, useContext, useEffect } from "react";
import { object, number } from "yup";

import { Form } from "components/Form";
import { FormTextField } from "components/FormTextField";
import { Modal } from "components/Modal";
import { Paragraph } from "components/Paragraph";
import { Title } from "components/Title";
import { ModalContext } from "contexts/ModalProvider";
import { useDeliveryCost } from "hooks/useDeliveryCost";
import { useToast } from "hooks/useToast";

export const DeliveryCostModal = () => {
  const { infoToast, errorToast } = useToast();
  const { deliveryConfigModalProps, setDeliveryConfigModalProps } =
    useContext(ModalContext);

  const { data: deliveryCost } = useDeliveryCost();

  const formik = useFormik({
    initialValues: {
      cost: 0,
      minAmount: 0,
    },
    validationSchema: object({
      cost: number()
        .required("Requerido")
        .min(0, "El costo debe ser mayor a 0"),
      minAmount: number()
        .required("Requerido")
        .min(0, "El monto mínimo debe ser mayor a 0"),
    }),
    onSubmit: async ({ cost, minAmount }) => {
      try {
        await deliveryConfigModalProps.onSubmit?.({ cost, minAmount });
        setDeliveryConfigModalProps({ open: false });
        infoToast("¡La configuración de envíos se ha guardado correctamente!");
      } catch (_) {
        errorToast("Error, vuelva a intentarlo.");
      }
    },
  });

  const onClose = useCallback(() => {
    if (!formik.isSubmitting) setDeliveryConfigModalProps({ open: false });
  }, [formik.isSubmitting, setDeliveryConfigModalProps]);

  useEffect(() => {
    if (deliveryConfigModalProps.open && deliveryCost) {
      formik.setFieldValue("cost", deliveryCost.cost);
      formik.setFieldValue("minAmount", deliveryCost.min_amount);
    }
  }, [deliveryConfigModalProps.open, deliveryCost]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Modal
      open={deliveryConfigModalProps.open}
      onClose={onClose}
      ariaTitle="Modal para configuración de envíos"
    >
      <Title style={{ marginBottom: 1 }}>Configuración de envíos</Title>
      <Paragraph>
        Ingresa el costo de envío y el mínimo de envío gratis:
      </Paragraph>
      <Form formik={formik}>
        <FormTextField
          name="cost"
          label="Costo de envío"
          type="number"
          isRequired
          fullWidth
        />{" "}
        <FormTextField
          name="minAmount"
          label="Mínimo de envío gratis"
          type="number"
          isRequired
          fullWidth
        />
        <Box display="flex" sx={{ marginTop: 2, gap: 5 }}>
          <Button
            disabled={formik.isSubmitting}
            onClick={onClose}
            style={{ flexGrow: 1 }}
            variant="outlined"
          >
            Cancelar
          </Button>
          <Button
            disabled={formik.isSubmitting || !formik.isValid}
            style={{ flexGrow: 1 }}
            variant="contained"
            type="submit"
          >
            Guardar
          </Button>
        </Box>
      </Form>
    </Modal>
  );
};
